import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import AddInputIcon from '@material-ui/icons/PlaylistAdd';
import RestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import 'react-trumbowyg/dist/trumbowyg.min.css'
import Trumbowyg from 'react-trumbowyg'
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2
    },
    card: {
        maxWidth: 300,
    },
    media: {
        height: 300,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center'
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    successButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#069c06",
        '&:hover': {
            backgroundColor: "#069c06",
        },
    },
    buttonProgress: {
        color: '#D64D29',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
});

class ProductBlankPage extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            deleteModal: false,
            uuidToDelete: ""
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEditorInputChange = this.handleEditorInputChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal(uuid)
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
            uuidToDelete: uuid
        });
    }

    handleInputChange(index, event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (name === "options")
        {
            this.props.productStore.blankpageParts[index][name] = JSON.stringify(value.split(";"))
        } else
        {
            this.props.productStore.blankpageParts[index][name] = value;
        }
    }

    handleEditorInputChange(index, event)
    {
        const target = event.target;
        const value = target.innerHTML;
        this.props.productStore.blankpageParts[index].content = value;
    }

    handleColorChangeComplete = (index, color) =>
    {
        this.props.productStore.blankpageParts[index]["text_color"] = color.hex;
    };

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.productStore.product.productid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    saveBlankpagePart(index)
    {
        this.props.productStore.saveBlankpagePart(this.props.match.params.id, index);
    }

    deleteBlankpagePart(uuid)
    {
        this.props.productStore.deleteBlankpagePart(this.props.match.params.id, uuid);
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }

    addBlankpagePart()
    {
        this.props.productStore.addBlankpagePart(this.props.match.params.id);
    }

    resetBlankpageParts()
    {
        this.props.productStore.resetBlankpageParts(this.props.match.params.id);
    }

    componentDidMount()
    {
        this.props.productStore.getBlankpageParts(this.props.match.params.id);
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Element löschen</DialogTitle>
                    <DialogContent>
                        Soll das Element wirklich gelöscht werden?
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteBlankpagePart(this.state.uuidToDelete)}
                                className={classes.warningButton}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Blankoseite für Produkt {this.props.productStore.product.name}
                </Typography>
                <form noValidate autoComplete="off">
                    {this.props.productStore.blankpageParts.map((item, index) =>
                        <div key={index}>
                            <Paper>
                                <Grid container
                                      direction="row"
                                      justify="flex-start"
                                      alignItems="flex-start">
                                    <Grid item xs={3}>
                                        <TextField
                                            id="type"
                                            name="type"
                                            label="Element"
                                            select
                                            className={classes.textField}
                                            value={item.type || "text"}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            SelectProps={{
                                                native: true,
                                                MenuProps: {
                                                    className: classes.menu,
                                                },
                                            }}
                                            margin="dense"
                                            fullWidth>
                                            <option value="html">Editor</option>
                                            <option value="button">Button</option>
                                            <option value="appstores">App und Play Store Logos</option>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField
                                            id="displayorder"
                                            name="displayorder"
                                            label="Reihenfolge"
                                            className={classes.textField}
                                            value={item.displayorder || ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container
                                      direction="row"
                                      justify="flex-start"
                                      alignItems="flex-start">
                                    {item.type === "button" &&
                                        <Grid item xs={3}>
                                            <TextField
                                                id="content"
                                                name="content"
                                                label="Button-Text"
                                                className={classes.textField}
                                                value={item.content || ''}
                                                onChange={this.handleInputChange.bind(this, index)}
                                                margin="dense"
                                                fullWidth
                                            />
                                        </Grid>
                                    }
                                    {item.type === "button" &&
                                        <Grid item xs={3}>
                                            <TextField
                                                id="destination"
                                                name="destination"
                                                label="Ziel-URL"
                                                className={classes.textField}
                                                value={item.destination || ''}
                                                onChange={this.handleInputChange.bind(this, index)}
                                                margin="dense"
                                                fullWidth
                                            />
                                        </Grid>
                                    }
                                    {item.type === "html" &&
                                        <Grid item xs={8} style={{marginLeft: "10px"}}>
                                            <Trumbowyg
                                                id={'react-trumbowyg' + item.uuid}
                                                data={item.content || ""}
                                                onBlur={this.handleEditorInputChange.bind(this, index)}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                                <hr/>
                                <Grid container
                                      direction="row"
                                      justify="flex-end"
                                      alignItems="flex-start">
                                    <Grid item style={{marginRight: "6px"}}>
                                        <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal(item.uuid)}
                                                className={classes.warningButton}>
                                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Löschen
                                        </Button>
                                        <Button variant="contained" size="small" color="secondary" onClick={() => this.saveBlankpagePart(index)}>
                                            <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Speichern
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <hr/>
                        </div>
                    )}
                    <Grid container spacing={16}>
                        <Grid item>
                            <br/>
                            <Button variant="contained" size="small" color="primary" onClick={() => this.addBlankpagePart()} className={classes.button}>
                                <AddInputIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                Feld hinzufügen
                            </Button>
                            {this.props.productStore.blankpageParts.length === 0 ? (
                                <Button variant="contained" size="small" color="default" onClick={() => this.resetBlankpageParts()}
                                        className={classes.successButton}>
                                    <RestoreIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Standard setzen
                                </Button>
                            ) : (
                                <Button variant="contained" size="small" color="default" onClick={() => this.resetBlankpageParts()}
                                        className={classes.warningButton}>
                                    <RestoreIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Zurücksetzen
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                    <hr/>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(ProductBlankPage));
